import { Util } from "codeArt/common";
import { theme } from 'codeArt/components/Base';

export const DeviceStatus = {
    running: 1,
    maintenance: 2,
    repair: 3,
    shutdown: 4,
    plannedShutdown: 5
}

export function getDSLabel(value) {
    switch (value) {
        case DeviceStatus.running: return "运行中";
        case DeviceStatus.maintenance: return "保养";
        case DeviceStatus.repair: return "维修";
        case DeviceStatus.shutdown: return "停机";
        case DeviceStatus.plannedShutdown: return "计划停机";
    }
}

export function getDSLabelColor(value) {
    switch (value) {
        case DeviceStatus.running: return "success";
        case DeviceStatus.maintenance: return "blue";
        case DeviceStatus.repair: return "warning";
        case DeviceStatus.shutdown: return "danger";
        case DeviceStatus.plannedShutdown: return "secondary";
    }
}

export const DeviceType = {
    beads: 1, //爆珠
    white: 2, //高透棒（常规白棒）
    hollow: 3, //中空棒
    duality : 4, //二元复合成型机
    ternary:5,// 三元复合成型机
}

export function getDevice(id,defaultValue=null) {
    return Devices.find((t) => t.Id == id) ||defaultValue;
}

export const FM01 = {
    Id: 1, Name: "L01 成型机", type:DeviceType.beads
}

export const FM02 = {
    Id: 2, Name: "L02 成型机", type:DeviceType.white
}

export const FM03 = {
    Id: 3, Name: "L03 成型机", type:DeviceType.hollow
}

export const FM04 = {
    Id: 4, Name: "L04 成型机", type:DeviceType.beads
}

export const FM05 = {
    Id: 5, Name: "L05 成型机", type:DeviceType.white
}

export const FM06 = {
    Id: 6, Name: "L06 成型机", type:DeviceType.hollow
}

export const FM07 = {
    Id: 7, Name: "L07 成型机", type:DeviceType.beads
}

export const FM08 = {
    Id: 8, Name: "L08 成型机", type:DeviceType.duality,complex:true
}

export const FM09 = {
    Id: 9, Name: "L09 成型机", type:DeviceType.ternary,complex:true
}


export const Devices = [
    FM01,
    FM02,
    FM03,
    FM04,
    FM05,
    FM06,
    FM07,
    FM08,
    FM09
];


export const ShiftAll = {  //0代表全部
    Id: 0, Name: "全部"
}

export const Shift0 = {
    Id: 1, Name: "当前班次"
}

export const Shift1 = {
    Id: 2, Name: "早班"
}

export const Shift2 = {
    Id: 3, Name: "中班"
}

export const Shift3 = {
    Id: 4, Name: "晚班"
}

export const Shifts = [
    ShiftAll,
    // Shift0,
    Shift1,
    Shift2,
    //Shift3
];

export const TeamAll = {  //0代表全部
    Id: 0, Name: "全部"
}

export const Team1 = {
    Id: 1, Name: "甲班"
}

export const Team2 = {
    Id: 2, Name: "乙班"
}

export const Team3 = {
    Id: 3, Name: "丙班"
}

export const Teams = [
    TeamAll,
    Team1,
    Team2,
    Team3
];

export function findItem(id, shift, items) {  //根据成型机、班次、机组，在指定的数组items里面找到对应的数据
    return Util.first(items, (item) => {
        return shift === item.Shift.Id && id === item.L.Id;
    });
}

export function DataProvider() {

    let _cache = {}; //上次访问的数据索引的缓存

    function getDataIndex(name) {
        return _cache[name] || 0;
    }

    function saveDataIndex(name, index) {
        _cache[name] = index;
    }


    this.get = (datas, name) => {

        if (datas.length === 1) return datas[0]; //只有一个数据项，表示指定该数据呈现

        let prevIndex = getDataIndex(name);
        let currentIndex = prevIndex;

        while (true) {
            currentIndex = getCycleIndex(currentIndex, datas.length - 1);
            if (currentIndex !== prevIndex) break;
        }

        saveDataIndex(name, currentIndex);
        let item = datas[currentIndex];

        return item;
    }

    function getCycleIndex(pointer, max) {
        if (Util.invalid(pointer) || pointer >= max) return 0;
        return pointer + 1;
    }

}